 import './about.css'
function About() {
  return (
    <div class="about-card">
      <h1>About Event</h1>
      <p>
        
          College events web app is an online event management software project
          that works for the functionality of an event manager.
          this web app is platform-independent and used to manage various event and activities in this project.
          This software application is designed for the effective management of events and activities
         and software system allows the user to manage events and activities efficiently.
         in the web app use can login and manage events like add event , delete event , update event and view event.
      </p>
    </div>
  );
}
export default About;
